/* Per-user, per-company UI preferences that survive navigation and logout.
   Backed by localStorage; every read and write is guarded, so a browser that
   blocks site data just behaves as if nothing was remembered. */

export function prefKey(name: string, userId: number | undefined, slug: string): string {
  return `oe.pref.${name}:${userId ?? "anon"}:${slug}`;
}

export function readPref<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writePref(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable — the page still works, it just forgets */
  }
}
